module.exports = __webpack_public_path__ + "static/media/23.e7582a7a.png";